import { StyledPillButton, text } from "@quickpoint.me/shared";
import { useEffect, useRef } from "react";
import styled from "styled-components";

/** Styled replacement for the viewer's window.confirm resume prompts.
 *  Chrome UI (not slide content): fixed accessible colors, shared pill
 *  buttons, alertdialog semantics, Escape/backdrop = "No". */

const Backdrop = styled.div`
	position: fixed;
	inset: 0;
	z-index: 4000;
	background: rgba(0, 0, 0, 0.35);
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Card = styled.div`
	background: #fff;
	color: #111;
	border-radius: 8px;
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
	padding: 28px 32px;
	max-width: 26rem;
	width: 90%;
	font-family: "Gill Sans", "Trebuchet MS", sans-serif;

	p {
		margin: 0 0 1.2rem;
		font-size: 1rem;
		line-height: 1.5;
	}
	.resume-buttons {
		display: flex;
		justify-content: flex-end;
		gap: 0.6rem;
	}
`;

export function ResumeDialog({
	message,
	onConfirm,
	onDismiss,
}: {
	message: string;
	onConfirm: () => void;
	onDismiss: () => void;
}) {
	const yesRef = useRef<HTMLButtonElement>(null);
	useEffect(() => {
		yesRef.current?.focus();
	}, []);

	return (
		<Backdrop onClick={onDismiss}>
			<Card
				role="alertdialog"
				aria-modal="true"
				aria-label={message}
				onClick={(e) => e.stopPropagation()}
				onKeyDown={(e) => {
					// keep arrows/space from paging the story underneath
					e.stopPropagation();
					if (e.key === "Escape") onDismiss();
				}}
			>
				<p>{message}</p>
				<div className="resume-buttons">
					<StyledPillButton onClick={onDismiss}>
						{text.reader.resumeNo}
					</StyledPillButton>
					<StyledPillButton ref={yesRef} $variant="dark" onClick={onConfirm}>
						{text.reader.resumeYes}
					</StyledPillButton>
				</div>
			</Card>
		</Backdrop>
	);
}
